// extracted by mini-css-extract-plugin
export var button = "_bl-4";
export var hasDarkBackground = "_bl-7";
export var hasLightBackground = "_bl-6";
export var iconWrapper = "_bl-0";
export var large = "_bl-2";
export var medium = "_bl-1";
export var small = "_bl-5";
export var xsmall = "_bl-3";